
import * as React from "react";
import { AppSettings } from "../AppSettings";
import axios, { AxiosRequestConfig } from 'axios';
import AppHelper from "./AppHelper";

class TariffHelper {

  static DownloadTariffData = async (entitieType: string,tariffIDs: string) => {
   
    let apiUrl =
    `${AppSettings.API_URL}Tariff/DownloadTariffEntity?entitieType=${entitieType}&tariffIds=${tariffIDs}`;
   
     
    const headers = {'Content-Type': 'blob', Authorization: "Bearer " + AppHelper.getUser().token };
    //  return false;
    const config: AxiosRequestConfig = {method: 'GET', url: apiUrl, responseType: 'arraybuffer', headers};
    
    try {
        const response = await axios(config);    
        
        const outputFilename = `Tariff_Data.xlsx`;

        // If you want to download file automatically using link attribute.
        const url = URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', outputFilename);
        document.body.appendChild(link);
        link.click();

        // OR you can save/write file locally.
        //fs.writeFileSync(outputFilename, response.data);
        return true;
    } catch (error) {
      console.log(error);       
       return false;
    }
}
  
  }

  export default TariffHelper;